export default {
  namespaced: true,
  state: {
    text: ALERT_MESSAGE,
    isVisible: !!ALERT_MESSAGE,
  },
  mutations: {
    setMessageVisible(state, payload) {
      state.isVisible = payload;
    },
  },
  actions: {
    hideMessage(context) {
      context.commit('setMessageVisible', false);
    },
  },
};
